import { j as e } from "../../../jsx-runtime-B3iL8JI7.js";
import { useState as H, useEffect as L } from "react";
import * as o from "@radix-ui/react-select";
import { faCaretUp as b, faCaretDown as h } from "@fortawesome/pro-solid-svg-icons";
import j from "./subcomponents/SelectScrollButton.js";
import M from "./subcomponents/SelectItem.js";
import f from "../Icon/Icon.js";
import l from "../../../utilities/tw.js";
import U, { getErrorId as A } from "../../subcomponents/formHelpers/ErrorText/ErrorText.js";
import F from "../../subcomponents/formHelpers/OptionalText/OptionalText.js";
import G from "../../subcomponents/formHelpers/InputLabel/InputLabel.js";
import J from "../../subcomponents/formHelpers/HelperText/HelperText.js";
import v from "../../../tailwindConfig/bclTwMerge.js";
const oe = ({
  id: t,
  value: m,
  onChange: g,
  onBlur: w,
  options: y,
  label: x,
  placeholder: S,
  errorText: i = "",
  helperIcon: I,
  helperText: N,
  required: p = !1,
  disabled: s = !1,
  avoidCollision: C = !1,
  buttonRef: E,
  className: P = "",
  autoComplete: R = "off",
  /**
   * The following props are **OPTIONAL**, and come from our Radix Select Primitive
   * https://www.radix-ui.com/primitives/docs/components/select#root
   */
  open: a,
  onOpenChange: d,
  defaultOpen: u,
  defaultValue: V,
  tabIndex: k = 0,
  // Setting default value to solve Safari and Firefox keyboard navigation issues
  ariaLive: D,
  dropdownZIndex: T = "1300"
  // Defaulting at 1300 to help it mix well with Modals, as dropdowns should likely always be visible... but we can revisit if issues arise.
}) => {
  const [c, n] = H(a || u);
  L(() => n(a), [a]);
  const $ = y.map(
    (r) => typeof r == "string" ? { key: r, display: r } : r
  ), z = v(
    l`flex justify-between rounded border-2 border-background-inverse bg-surface px-4 py-3 font-medium hover:border-primary-hover focus-visible:border-primary-active focus-visible:outline-none data-[placeholder]:text-disabled`,
    c && l`border-primary-active`,
    i && l`border-error bg-error-surface text-error hover:border-error focus-visible:border-error`,
    s && l`pointer-events-none cursor-default border-disabled bg-disabled-surface text-disabled focus-within:border-disabled hover:border-disabled `
  );
  return /* @__PURE__ */ e.jsxs("div", { className: v("flex flex-col gap-1", P), children: [
    x && /* @__PURE__ */ e.jsx(
      G,
      {
        id: t,
        label: x,
        showDisabled: s,
        showErrorState: !!i,
        onClick: () => {
          s || n(!0);
        }
      }
    ),
    /* @__PURE__ */ e.jsxs(
      o.Root,
      {
        value: m,
        onValueChange: g,
        disabled: s,
        required: p,
        open: c,
        onOpenChange: (r) => {
          d == null || d(r), typeof a > "u" && n(r);
        },
        defaultOpen: u,
        defaultValue: V,
        autoComplete: R,
        children: [
          /* @__PURE__ */ e.jsxs(
            o.Trigger,
            {
              id: t,
              ref: E,
              onBlur: w,
              className: z,
              "aria-disabled": s,
              "data-testid": `${t}-select-trigger`,
              tabIndex: k,
              "aria-describedby": A(t),
              "aria-invalid": i ? !0 : void 0,
              children: [
                /* @__PURE__ */ e.jsx("span", { className: "truncate", children: /* @__PURE__ */ e.jsx(
                  o.Value,
                  {
                    placeholder: S,
                    "data-testid": `${t}-select-value-display`
                  }
                ) }),
                /* @__PURE__ */ e.jsx(o.Icon, { children: /* @__PURE__ */ e.jsx(
                  f,
                  {
                    icon: c ? b : h,
                    className: "text-neutral-inverse"
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ e.jsx(o.Portal, { children: /* @__PURE__ */ e.jsxs(
            o.Content,
            {
              position: "popper",
              side: "bottom",
              sideOffset: 8,
              avoidCollisions: C,
              className: "max-h-[--radix-select-content-available-height] w-[--radix-select-trigger-width] overflow-hidden rounded border-0 bg-surface p-0 shadow-lg",
              style: { zIndex: T },
              children: [
                /* @__PURE__ */ e.jsx(j, { direction: "up", children: /* @__PURE__ */ e.jsx(f, { icon: b }) }),
                /* @__PURE__ */ e.jsx(o.Viewport, { className: "p-1", children: $.map(({ key: r, display: B }) => /* @__PURE__ */ e.jsx(
                  M,
                  {
                    value: r,
                    isCurrentlySelected: r === m,
                    children: B
                  },
                  r
                )) }),
                /* @__PURE__ */ e.jsx(j, { direction: "down", children: /* @__PURE__ */ e.jsx(f, { icon: h }) })
              ]
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ e.jsx(J, { id: t, helperText: N, helperIcon: I }),
    !p && /* @__PURE__ */ e.jsx(F, { id: t }),
    /* @__PURE__ */ e.jsx(U, { id: t, text: i, ariaLive: D })
  ] });
};
export {
  oe as default
};
